import React from "react";
import { ArrowRight } from "lucide-react";
import { FadeUpGroup } from "../components/FadeUpGroup";
import { INTEGRATION_CATEGORIES } from "../lib/integrations";

export const IntegrationsPage = () => {
    return (
        <section className="section" data-testid="integrations-page">
            <div className="container">
                <div className="section-head">
                    <span className="eyebrow">Integrations</span>
                    <h1 className="h1" style={{ marginTop: 18 }}>Connects to whatever you already run</h1>
                    <p>Scitus.ai sits on top of your existing stack — POS, accounting, banking, comms, cloud storage. Out-of-the-box connectors plus a REST API for everything else.</p>
                </div>
                <FadeUpGroup>
                    <div className="integration-grid">
                        {INTEGRATION_CATEGORIES.map((cat) => (
                            <div key={cat.key} className="card fade-up" data-testid={`integration-cat-${cat.key}`}>
                                <span className="icon-square"><cat.icon size={20} /></span>
                                <h3 className="h3" style={{ marginTop: 14, fontSize: "1.05rem" }}>{cat.name}</h3>
                                <p className="muted" style={{ marginTop: 6, fontSize: "0.88rem" }}>{cat.intent}</p>
                                <div className="industry-chips" style={{ marginTop: 14 }}>
                                    {cat.items.map((it) => <span key={it} className="chip" style={{ fontSize: "0.75rem" }}>{it}</span>)}
                                </div>
                            </div>
                        ))}
                    </div>
                </FadeUpGroup>
                <div className="cta-banner" style={{ marginTop: 64 }}>
                    <div>
                        <h2 className="h2">Don't see your tool?</h2>
                        <p className="lead mt-4">If it has an API, we can connect it within 24 hours. Tell us what you'd like to see next.</p>
                    </div>
                    <a href="/contact" className="btn btn-primary btn-lg" data-testid="integrations-cta">
                        Request a connector <ArrowRight size={18} />
                    </a>
                </div>
            </div>
        </section>
    );
};

export default IntegrationsPage;
